import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ProgressBar(props) {
  const {
    progress, color, label, description, className, descriptionLink, type
  } = props;
  // Ensure progress is between 0 and 100
  const normalizedProgress = Math.min(100, Math.max(0, progress));

  return (
    <div className={classNames('pgn__progress-bar-wrapper', className)}>
      {label && (
        <div className="pgn__progress-bar-label">
          <span className="pgn__progress-bar-label-text">{label}</span>
          <span className="pgn__progress-bar-label-value">{normalizedProgress}%</span>
        </div>
      )}
      <div className="pgn__progress-bar-body">
        <div className="pgn__progress-bar-progress-outer">
          <div
            data-testid="progress-bar"
            className={classNames('pgn__progress-bar-progress-inner', `pgn__progress-bar-progress-${color}`)}
            style={{ width: `${normalizedProgress}%` }}
          />
        </div>
        {type === 'inline' && <span className="pgn__progress-bar-progress-text">{normalizedProgress}%</span>}
      </div>

      {description && <div className="pgn__progress-bar-description">
        {descriptionLink && <a href={descriptionLink.href} className="pgn__progress-bar-description-link">{descriptionLink.label}</a>}
        {description && <span className="pgn__progress-bar-description-text">{description}</span>}
      </div>}

    </div>
  );
}

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  color: PropTypes.oneOf(['blue', 'red', 'orange', 'green']),
  label: PropTypes.string,
  description: PropTypes.string,
  descriptionLink: PropTypes.exact({ label: PropTypes.string, href: PropTypes.string }),
  className: PropTypes.string,
  type: PropTypes.oneOf(['inline', 'default'])
};

ProgressBar.defaultProps = {
  color: 'blue',
  label: '',
  description: '',
  descriptionLink: {},
  className: '',
  type: 'default'
};

export default ProgressBar;
